import React from "react";
import MultiSelectDropdown from "../../dropdown/MultiSelectDropdown.js";
import ValidationText from "../../../utils/validation/ValidationText.js";
import moment from 'moment';
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";



const SecondPageInwardOutward = (props) => {
    return (
        <>
            <div className="item-form mb-4">
                <div className="item-grp flex gap-2.5 mb-3">
                    <div className="input-grp w-full">
                        <label>Date</label>
                        <input
                            type="date"
                            id="date"
                            name="date"
                            className={`inputFocus ${props.validState?.error?.date ? "errorInput" : ""}`}
                            autocomplete="off"
                            value={props.postDetails.date}
                            onChange={(event) =>
                                props.handleChange(event, "date", "postDetails")
                            }
                        />
                        {/* <ValidationText error={props.validState.error.date} /> */}

                    </div>
                    <div className="input-grp w-full">
                        <label>Courier</label>
                        <select
                            name="courier"
                            className={` ${props.validState?.error?.courier ? "errorInput" : ""}`}
                            value={props.postDetails.courier && props.postDetails.courier !== 'Select' && props.courierList.find(
                                (party) => party.courier === props.postDetails.courier
                            ).courier}
                            onChange={(event) =>
                                props.handleDropDownChange(
                                    event,
                                    "courier",
                                    "postDetails"
                                )
                            }
                        >
                            <option>Select</option>
                            {props.courierList.map((x, key) => (
                                <option key={key} value={x.courier}>
                                    {x.courier}
                                </option>
                            ))}
                        </select>
                        {/* <ValidationText error={props.validState.error.courier} /> */}
                    </div>

                    <div className="input-grp w-full">
                        <label>P.O.D No.</label>
                        <input
                            type="text"
                            id="podNo"
                            name="podNo"
                            className={`inputFocus ${props.validState?.error?.podNo ? "errorInput" : ""}`}
                            autocomplete="off"
                            value={props.postDetails.podNo}
                            onChange={(event) =>
                                props.handleChange(event, "podNo", "postDetails")
                            }
                        />
                        {/* <ValidationText error={props.validState.error.podNo} /> */}
                    </div>
                </div>

                <div className="item-grp flex gap-2.5 mb-3">
                    <div className="input-grp min-w-[32.9%]">
                        <label>Party Name</label>
                        <MultiSelectDropdown
                            drpIdentity="partyId"
                            options={props.partyDropdownList}
                            closeMenuOnSelect={true}
                            className={` ${props.validState?.error?.partyId ? "errorInput" : ""}`}
                            hideSelectedOptions={false}
                            onChange={(selected) =>
                                props.setFilterParameters(selected, "partyId")
                            }
                            allowSelectAll={false}
                            value={props.partyDropdownList.filter(
                                (party) =>
                                    party.value === props.postDetails.partyId
                            )}
                        />
                        {/* <ValidationText error={props.validState.error.partyId} /> */}
                    </div>
                    <div className="input-grp w-full">
                        <label>Narration</label>
                        <input
                            type="text"
                            id="narration"
                            name="narration"
                            className="inputFocus"
                            autocomplete="off"
                            value={props.postDetails.narration}
                            onChange={(event) =>
                                props.handleChange(event, "narration", "postDetails")
                            }
                        />
                    </div>
                </div>

            </div>
            <div className="btn-grp">
                {props.isEditing === true ? (
                    <button
                        className="add-btn"
                        disabled={props.isLoading}
                        onClick={props.addEditPost}
                    >
                        {props.isLoading ? <FontAwesomeIcon icon={faSpinner} className="loader" /> : "Save"}
                    </button>
                ) : (
                    <button
                        className="add-btn"
                        disabled={props.isLoading}
                        onClick={props.addEditPost}
                    >
                        {props.isLoading ? <FontAwesomeIcon icon={faSpinner} className="loader" /> : "Add"}
                    </button>
                )}
                <button className="cancel-btn"
                    onClick={props.openGridView}
                    disabled={props.isLoading}
                >Cancel</button>

            </div>
        </>
    );
};
export default SecondPageInwardOutward;